/**
 * Platform query keys, declared in one place. Scattered inline arrays are how
 * cache invalidation quietly stops working. Each module declares its own keys
 * next to its hooks, rooted at its module id.
 */
export const queryKeys = {
   session: ['session'] as const,
   /** Pickable languages. */
   /** Every catalogue, for invalidation. */
   catalogues: ['i18n'] as const,
   /** Tenant overrides make the catalogue per organisation (`null` = platform defaults). */
   catalogue: (locale: string, organizationId: string | null) => ['i18n', locale, organizationId] as const,
   platform: {
      organizations: ['platform', 'organizations'] as const,
      orgMembers: ['platform', 'org-members'] as const,
      orgRoles: ['platform', 'org-roles'] as const,
      orgModules: ['platform', 'org-modules'] as const,
      orgPermissions: ['platform', 'org-permissions'] as const,
      orgSso: ['platform', 'org-sso'] as const,
      platformSso: ['platform', 'platform-sso'] as const,
      orgEmail: ['platform', 'org-email'] as const,
      platformEmail: ['platform', 'platform-email'] as const,
      orgAuthPolicy: ['platform', 'org-auth-policy'] as const,
      passkeys: ['platform', 'passkeys'] as const
   },
   /** Public login probe — keyed by the validated email string. */
   ssoAvailable: (email: string) => ['sso-available', email] as const
} as const;
